import { Form, Input } from 'antd'
import dayjs from 'dayjs'
import { Bills } from 'gadjet-v2-types/dist/model'
import { useMemo } from 'react'

import mask from '@utils/mask'

import LocalDatePicker from '@components/atoms/LocalDatePicker'
import FormListTable, { FormListTableColumn } from '@components/molecules/FormListTable'

type Props = { bill?: Partial<Bills> }

export default function BillTaxInvoiceDetailList({ bill }: Props): JSX.Element {
  const defaultValue = useMemo(
    () => ({
      serialNum: '',
      purchaseDT: bill?.startDate || dayjs().format('YYYYMMDD'),
      itemName: '',
      qty: '',
      unitCost: '',
      supplyCost: '0',
      tax: '0',
    }),
    [bill]
  )

  const columns: FormListTableColumn[] = useMemo(
    () => [
      {
        label: '일련번호',
        width: '8%',
        render: (field) => (
          <Form.Item name={[field.name, 'serialNum']} isListField required noStyle>
            <Input />
          </Form.Item>
        ),
      },
      {
        label: '구매일',
        width: '150px',
        render: (field) => (
          <Form.Item
            noStyle
            name={[field.name, 'purchaseDT']}
            isListField
            getValueProps={(value) => ({ value: dayjs(value) })}
            getValueFromEvent={(value) => dayjs(value).format('YYYYMMDD')}
          >
            <LocalDatePicker allowClear={false} />
          </Form.Item>
        ),
      },
      {
        label: '품명',
        width: '16%',
        render: (field) => (
          <Form.Item name={[field.name, 'itemName']} isListField noStyle>
            <Input />
          </Form.Item>
        ),
      },
      {
        label: '수량',
        width: '8%',
        render: (field) => (
          <Form.Item name={[field.name, 'qty']} isListField noStyle>
            <Input />
          </Form.Item>
        ),
      },
      {
        label: '단가',
        render: (field) => (
          <Form.Item name={[field.name, 'unitCost']} isListField noStyle {...mask.krw}>
            <Input />
          </Form.Item>
        ),
      },
      {
        label: '공급가액',
        render: (field) => (
          <Form.Item name={[field.name, 'supplyCost']} isListField noStyle {...mask.krw}>
            <Input />
          </Form.Item>
        ),
      },
      {
        label: '세액',
        render: (field) => (
          <Form.Item name={[field.name, 'tax']} isListField noStyle {...mask.krw}>
            <Input />
          </Form.Item>
        ),
      },
    ],
    []
  )

  return <FormListTable name="detailList" columns={columns} title="품목" defaultValue={defaultValue} />
}
